import { CollapsibleSection } from '@/app/components/shared/viewer/CollapsibleSection';
import { Grid, GridProps } from '@mantine/core';
import { RapidModel } from '@/types/rapidModel';
import { ResultColumn, TextColumn } from '@/app/assets/details/atoms/OutputModelMetadata';
import { showErrorNotification } from '@/app/components/shared/notifications';
import { Fragment, useEffect } from 'react';
import { QualityControlGalleryModal } from '@/app/components/modal/QualityControlGalleryModal';
import { useRapidModelRendersQuery } from '../hooks/useRapidModelRenders';
import { useRapidModelParent } from '@/app/assets/hooks/useAssetsQuery';

type RawModelMetadataProps = { asset: RapidModel } & GridProps;

export function QualityControl({ asset, ...gridProps }: RawModelMetadataProps) {
  const { data: imagesData, isLoading, isError } = useRapidModelRendersQuery(asset.id);
  const assetSource = useRapidModelParent(asset.id);

  useEffect(() => {
    if (isError) {
      showErrorNotification({ title: 'Error', message: 'There was an error while downloading the QC report images' });
    }
  }, [isError]);

  return (
    <CollapsibleSection title='Optimization Quality Control'>
      <Grid columns={10} {...gridProps} gutter='xs'>
        <TextColumn span={4}></TextColumn>
        <TextColumn span={2}>Max Score</TextColumn>
        <TextColumn span={2}>Avg Score</TextColumn>
        <TextColumn span={2}>QC Report</TextColumn>

        {asset.meta?.qc?.map((entry, index) => (
          <Fragment key={index}>
            {Object.keys(entry).map((key) => {
              const qcObject = entry[key];
              return (
                <Fragment key={key}>
                  <TextColumn textProps={{ ta: 'left' }} span={4}>
                    {key.toUpperCase()}:{' '}
                  </TextColumn>
                  <ResultColumn span={2} highlight={false}>
                    {Number(qcObject.maxScore).toFixed(2)}
                  </ResultColumn>
                  <ResultColumn span={2} highlight={false}>
                    {Number(qcObject.avgScore).toFixed(2)}
                  </ResultColumn>
                  <TextColumn span={2} px={2}>
                    <QualityControlGalleryModal title={asset.name} images={imagesData ? imagesData : {}} format={key} isSourceMax={assetSource?.format === 'max'} />
                  </TextColumn>
                </Fragment>
              );
            })}
          </Fragment>
        ))}
      </Grid>
    </CollapsibleSection>
  );
}
